import './AboutUs.css';
import { useState, useRef, useEffect } from 'react';
import WaveSurfer from 'wavesurfer.js';

const AboutUs = () => {
  const waveformRef = useRef(null);
  const wavesurfer = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    wavesurfer.current = WaveSurfer.create({
      container: waveformRef.current,
      waveColor: 'white',
      progressColor: '#91e6ff',
      barWidth: 2,
      barRadius: 3,
      cursorWidth: 1,
      height: 100,
      barGap: 3,
    });
    wavesurfer.current.load('/audios/convenio.mpeg');

    wavesurfer.current.on('play', () => {
      setIsPlaying(true);
    });
    wavesurfer.current.on('pause', () => {
      setIsPlaying(false);
    });

    wavesurfer.current.on('finish', () => {
      setIsPlaying(false);
    });

    return () => {
      wavesurfer.current.destroy();
    };
  }, []);

  const handlePlayPause = () => {
    wavesurfer.current.playPause();
  };

  return (
    <section className='aboutus container' id='about-us'>
      <div className='about-us-info'>
        <h2 className='about-us-header'>
          Los <span className='lancaster-color'>resultados</span> que necesitas
        </h2>
        <p className='about-us-paragraph'>
          Escucha esta grabación de un deudor que se comprometió a pagar su deuda.
        </p>
      </div>
      <div className='about-us-img-wrapper'>
        <div ref={waveformRef} style={{ width: '100%' }} />
        <button onClick={handlePlayPause} className="about-us-button">
          {isPlaying ? 'Pausar' : 'Play'}
        </button>
      </div>
      <div className='section-background-desktop'>
        <div className='background-desktop'>
          <div className='overlay-wrap'>
            <div className='overlay-top'></div>
            <div className='overlay-bottom'></div>
            <div className='overlay-right'></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
